export const MATOMO_EVENTS_CONFIG = []
